import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useThemePalette } from "common/hooks/theme_palette";

export default function ResetPasswordSuccess() {
  const { t } = useTranslation();
  const { gray } = useThemePalette();

  return (
    <>
      <Stack sx={{ gap: 5 }}>
        <Typography fontFamily="Cairo" fontSize="32px" fontWeight="400">
          {t("auth.reset_password_success.title")}
        </Typography>
        <Typography fontFamily="Cairo" fontSize="18px" color={gray}>
          {t("auth.reset_password_success.subtitle")}
        </Typography>
      </Stack>
    </>
  );
}
